// extracted by mini-css-extract-plugin
export default {"canvas":"lKIlrb"};